import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.module.css';
import { CancelablePromise, makeCancelablePromise } from './makeCancelablePromise';
import { Celebration } from '../../../vendor/Celebration';
import { Fade } from '../../../vendor/Motion/Fade';
import { getGradient } from '../../../vendor/Utils';

const DEFAULT_BACKGROUND = styles.defaultbackground;

interface Props {
  coverArtImagePath?: string;
  showCelebration?: boolean;
  shouldFadeIn?: boolean;
}

interface State {
  backgroundGradient: string;
  palette: number[][];
}

export class PreviewBackground extends PureComponent<Props, State> {
  static propTypes = {
    coverArtImagePath: PropTypes.string,
    showCelebration: PropTypes.bool,
    shouldFadeIn: PropTypes.bool,
  };
  static defaultProps = {
    coverArtImagePath: undefined,
    shouldFadeIn: true,
  };
  state = {
    backgroundGradient: DEFAULT_BACKGROUND,
    palette: [],
  };

  backgroundGradientPromise: CancelablePromise | null = null;

  componentDidMount() {
    this.setbackground(this.props.coverArtImagePath);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.coverArtImagePath !== this.props.coverArtImagePath) {
      this.setbackground(nextProps.coverArtImagePath);
    }
  }
  componentWillUnmount() {
    /* istanbul ignore next */
    if (this.backgroundGradientPromise) {
      this.backgroundGradientPromise.cancel();
      this.backgroundGradientPromise = null;
    }
  }
  setbackground = imagePath => {
    if (!imagePath) {
      this.setState({
        backgroundGradient: DEFAULT_BACKGROUND,
      });
      return;
    }
    this.backgroundGradientPromise = makeCancelablePromise(
      this.generatePredominanCssGradient(imagePath),
    );
    this.backgroundGradientPromise.promise.then(
      ({ backgroundGradient, palette }) => {
        this.setState({ backgroundGradient, palette });
      },
      /* istanbul ignore next */ error => {
        /* istanbul ignore next */
        if (error && !error.isCanceled) {
          /* istanbul ignore next */
          this.setState({ backgroundGradient: DEFAULT_BACKGROUND });
        }
      },
    );
  };

  generatePredominanCssGradient = imagePath => getGradient(imagePath);

  render() {
    const { showCelebration, shouldFadeIn } = this.props;
    const { backgroundGradient, palette } = this.state;

    const content = (
      <div
        style={{
          // we cover up the header bar on the Finished (aka /done) screen
          top: showCelebration ? '-220px' : '0',
        }}
        className={cn(styles.gradient_container, showCelebration && styles.celebration)}
      >
        <div
          className={styles.gradient_bg}
          style={{
            background: backgroundGradient,
          }}
        />
        <Fade in={showCelebration} appear timeout={700}>
          <Celebration palette={palette} />
        </Fade>
      </div>
    );

    /* istanbul ignore next */
    if (!shouldFadeIn) {
      return <div>{content}</div>;
    }

    return (
      <Fade in={backgroundGradient !== DEFAULT_BACKGROUND} timeout={0}>
        {content}
      </Fade>
    );
  }
}
